import { Outlet } from 'react-router-dom';
import TopNavbar from '../components/TopNavbar';
import Sidebar from './SideBar';

const MainLayout = () => {
  return (
    <div className="main-layout title2">
      <Sidebar/>
      <div className="main-content ">
        <Outlet />
      </div>
    </div>
  );
};

export default MainLayout;
